module.exports = __webpack_public_path__ + "img/collect-desc.d2923f97.png";